import React from 'react';
import { NavigationCardId } from './SNOWHomeConstants';

/** Snowflake pattern overlay for the hero section */
export const HeroSnowflakes: React.FC = () => (
	<svg
		className="snow-home__hero-snowflakes"
		xmlns="http://www.w3.org/2000/svg"
		width="100%"
		height="100%"
		aria-hidden="true"
	>
		<defs>
			<pattern
				id="snowflakes"
				x="0"
				y="0"
				width="200"
				height="200"
				patternUnits="userSpaceOnUse"
			>
				<text x="20" y="30" fontSize="16" fill="white" opacity="0.06">
					❄
				</text>
				<text x="120" y="55" fontSize="12" fill="white" opacity="0.05">
					❄
				</text>
				<text x="60" y="80" fontSize="20" fill="white" opacity="0.07">
					❄
				</text>
				<text x="160" y="110" fontSize="14" fill="white" opacity="0.04">
					❄
				</text>
				<text x="30" y="140" fontSize="10" fill="white" opacity="0.06">
					❄
				</text>
				<text x="100" y="170" fontSize="18" fill="white" opacity="0.05">
					❄
				</text>
				<text x="170" y="190" fontSize="11" fill="white" opacity="0.06">
					❄
				</text>
			</pattern>
		</defs>
		<rect width="100%" height="100%" fill="url(#snowflakes)" />
	</svg>
);

/** Card banner icons — white SVGs for gradient backgrounds */
export const CARD_SVGS: Record<NavigationCardId, JSX.Element> = {
	'manage-workflows': (
		<svg
			width="220"
			height="80"
			viewBox="145 62 290 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			{/* Node 1 - Start */}
			<rect
				x="155"
				y="82"
				width="50"
				height="28"
				rx="6"
				fill="rgba(0,180,216,0.35)"
				stroke="#00b4d8"
				strokeWidth="1.5"
			/>
			<rect x="162" y="90" width="36" height="4" rx="2" fill="#00b4d8" />
			<rect
				x="165"
				y="98"
				width="28"
				height="3"
				rx="1.5"
				fill="rgba(255,255,255,0.25)"
			/>
			{/* Arrow 1→2 */}
			<line
				x1="205"
				y1="96"
				x2="235"
				y2="82"
				stroke="rgba(255,255,255,0.35)"
				strokeWidth="1.5"
			/>
			<line
				x1="205"
				y1="96"
				x2="235"
				y2="110"
				stroke="rgba(255,255,255,0.35)"
				strokeWidth="1.5"
			/>
			{/* Node 2a - top branch */}
			<rect
				x="235"
				y="68"
				width="50"
				height="28"
				rx="6"
				fill="rgba(123,47,247,0.35)"
				stroke="#7b2ff7"
				strokeWidth="1.5"
			/>
			<rect x="242" y="76" width="36" height="4" rx="2" fill="#7b2ff7" />
			<rect
				x="245"
				y="84"
				width="28"
				height="3"
				rx="1.5"
				fill="rgba(255,255,255,0.25)"
			/>
			{/* Node 2b - bottom branch */}
			<rect
				x="235"
				y="104"
				width="50"
				height="28"
				rx="6"
				fill="rgba(255,153,0,0.35)"
				stroke="#ff9900"
				strokeWidth="1.5"
			/>
			<rect x="242" y="112" width="36" height="4" rx="2" fill="#ff9900" />
			<rect
				x="245"
				y="120"
				width="28"
				height="3"
				rx="1.5"
				fill="rgba(255,255,255,0.25)"
			/>
			{/* Arrow 2a→3 */}
			<line
				x1="285"
				y1="82"
				x2="320"
				y2="96"
				stroke="rgba(255,255,255,0.35)"
				strokeWidth="1.5"
			/>
			{/* Arrow 2b→3 */}
			<line
				x1="285"
				y1="118"
				x2="320"
				y2="96"
				stroke="rgba(255,255,255,0.35)"
				strokeWidth="1.5"
			/>
			{/* Node 3 - merge */}
			<rect
				x="320"
				y="82"
				width="50"
				height="28"
				rx="6"
				fill="rgba(76,175,80,0.35)"
				stroke="#4caf50"
				strokeWidth="1.5"
			/>
			<rect x="327" y="90" width="36" height="4" rx="2" fill="#4caf50" />
			<rect
				x="330"
				y="98"
				width="28"
				height="3"
				rx="1.5"
				fill="rgba(255,255,255,0.25)"
			/>
			{/* Arrow 3→4 */}
			<line
				x1="370"
				y1="96"
				x2="395"
				y2="96"
				stroke="rgba(255,255,255,0.35)"
				strokeWidth="1.5"
			/>
			{/* Node 4 - end */}
			<rect
				x="395"
				y="82"
				width="35"
				height="28"
				rx="14"
				fill="rgba(0,180,216,0.35)"
				stroke="#00b4d8"
				strokeWidth="1.5"
			/>
			<circle cx="412" cy="96" r="6" fill="#00b4d8" opacity="0.6" />
			<path
				d="M409 96l2 2 4-4"
				stroke="white"
				strokeWidth="1.5"
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	'application-management': (
		<svg
			width="220"
			height="80"
			viewBox="0 0 220 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			{/* Table header */}
			<rect
				x="10"
				y="5"
				width="200"
				height="8"
				rx="4"
				fill="rgba(0,0,0,0.15)"
			/>
			<rect x="10" y="18" width="200" height="1" fill="rgba(0,0,0,0.1)" />
			{/* Row 1 */}
			<rect x="10" y="23" width="60" height="6" rx="3" fill="rgba(0,0,0,0.2)" />
			<rect
				x="80"
				y="23"
				width="45"
				height="6"
				rx="3"
				fill="rgba(123,47,247,0.7)"
			/>
			<rect
				x="135"
				y="23"
				width="30"
				height="6"
				rx="3"
				fill="rgba(76,175,80,0.7)"
			/>
			<rect
				x="175"
				y="23"
				width="35"
				height="6"
				rx="3"
				fill="rgba(0,0,0,0.12)"
			/>
			<rect x="10" y="35" width="200" height="1" fill="rgba(0,0,0,0.1)" />
			{/* Row 2 */}
			<rect x="10" y="40" width="50" height="6" rx="3" fill="rgba(0,0,0,0.2)" />
			<rect
				x="80"
				y="40"
				width="45"
				height="6"
				rx="3"
				fill="rgba(255,100,0,0.7)"
			/>
			<rect
				x="135"
				y="40"
				width="30"
				height="6"
				rx="3"
				fill="rgba(220,50,50,0.6)"
			/>
			<rect
				x="175"
				y="40"
				width="35"
				height="6"
				rx="3"
				fill="rgba(0,0,0,0.12)"
			/>
			<rect x="10" y="52" width="200" height="1" fill="rgba(0,0,0,0.1)" />
			{/* Row 3 */}
			<rect x="10" y="57" width="65" height="6" rx="3" fill="rgba(0,0,0,0.2)" />
			<rect
				x="80"
				y="57"
				width="45"
				height="6"
				rx="3"
				fill="rgba(15,27,45,0.6)"
			/>
			<rect
				x="135"
				y="57"
				width="30"
				height="6"
				rx="3"
				fill="rgba(76,175,80,0.7)"
			/>
			<rect
				x="175"
				y="57"
				width="35"
				height="6"
				rx="3"
				fill="rgba(0,0,0,0.12)"
			/>
			<rect x="10" y="69" width="200" height="1" fill="rgba(0,0,0,0.1)" />
		</svg>
	),
	'user-dashboard': (
		<svg
			width="220"
			height="80"
			viewBox="0 0 220 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			{/* Bar chart with colorful bars */}
			<rect
				x="15"
				y="55"
				width="22"
				height="20"
				rx="3"
				fill="rgba(0,180,216,0.5)"
				stroke="#00b4d8"
				strokeWidth="1"
			/>
			<rect
				x="45"
				y="35"
				width="22"
				height="40"
				rx="3"
				fill="rgba(123,47,247,0.5)"
				stroke="#7b2ff7"
				strokeWidth="1"
			/>
			<rect
				x="75"
				y="15"
				width="22"
				height="60"
				rx="3"
				fill="rgba(76,175,80,0.5)"
				stroke="#4caf50"
				strokeWidth="1"
			/>
			<rect
				x="105"
				y="40"
				width="22"
				height="35"
				rx="3"
				fill="rgba(255,153,0,0.5)"
				stroke="#ff9900"
				strokeWidth="1"
			/>
			<rect
				x="135"
				y="25"
				width="22"
				height="50"
				rx="3"
				fill="rgba(0,180,216,0.5)"
				stroke="#00b4d8"
				strokeWidth="1"
			/>
			<rect
				x="165"
				y="45"
				width="22"
				height="30"
				rx="3"
				fill="rgba(123,47,247,0.5)"
				stroke="#7b2ff7"
				strokeWidth="1"
			/>
			{/* Trend line */}
			<polyline
				points="26,50 56,30 86,10 116,35 146,20 176,40"
				stroke="rgba(255,255,255,0.5)"
				strokeWidth="2"
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			{/* Dots on trend line */}
			<circle cx="26" cy="50" r="3" fill="#00b4d8" />
			<circle cx="56" cy="30" r="3" fill="#7b2ff7" />
			<circle cx="86" cy="10" r="3" fill="#4caf50" />
			<circle cx="116" cy="35" r="3" fill="#ff9900" />
			<circle cx="146" cy="20" r="3" fill="#00b4d8" />
			<circle cx="176" cy="40" r="3" fill="#7b2ff7" />
		</svg>
	),
	'task-dashboard': (
		<svg
			width="220"
			height="80"
			viewBox="0 0 220 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			{/* Task cards with status indicators */}
			{/* Task 1 - completed */}
			<rect
				x="10"
				y="5"
				width="95"
				height="30"
				rx="5"
				fill="rgba(76,175,80,0.2)"
				stroke="#4caf50"
				strokeWidth="1.2"
			/>
			<rect
				x="18"
				y="12"
				width="45"
				height="4"
				rx="2"
				fill="rgba(255,255,255,0.3)"
			/>
			<rect
				x="18"
				y="20"
				width="30"
				height="3"
				rx="1.5"
				fill="rgba(255,255,255,0.15)"
			/>
			<circle cx="92" cy="20" r="6" fill="rgba(76,175,80,0.4)" />
			<path
				d="M89 20l2 2 4-4"
				stroke="#4caf50"
				strokeWidth="1.5"
				fill="none"
				strokeLinecap="round"
			/>
			{/* Task 2 - in progress */}
			<rect
				x="115"
				y="5"
				width="95"
				height="30"
				rx="5"
				fill="rgba(0,180,216,0.2)"
				stroke="#00b4d8"
				strokeWidth="1.2"
			/>
			<rect
				x="123"
				y="12"
				width="50"
				height="4"
				rx="2"
				fill="rgba(255,255,255,0.3)"
			/>
			<rect
				x="123"
				y="20"
				width="35"
				height="3"
				rx="1.5"
				fill="rgba(255,255,255,0.15)"
			/>
			<circle cx="197" cy="20" r="6" fill="rgba(0,180,216,0.4)" />
			<rect
				x="194"
				y="17"
				width="6"
				height="6"
				rx="1"
				fill="#00b4d8"
				opacity="0.7"
			/>
			{/* Task 3 - pending */}
			<rect
				x="10"
				y="43"
				width="95"
				height="30"
				rx="5"
				fill="rgba(255,153,0,0.2)"
				stroke="#ff9900"
				strokeWidth="1.2"
			/>
			<rect
				x="18"
				y="50"
				width="40"
				height="4"
				rx="2"
				fill="rgba(255,255,255,0.3)"
			/>
			<rect
				x="18"
				y="58"
				width="55"
				height="3"
				rx="1.5"
				fill="rgba(255,255,255,0.15)"
			/>
			<circle cx="92" cy="58" r="6" fill="rgba(255,153,0,0.4)" />
			<rect
				x="89"
				y="56"
				width="6"
				height="4"
				rx="1"
				fill="#ff9900"
				opacity="0.7"
			/>
			{/* Task 4 - completed */}
			<rect
				x="115"
				y="43"
				width="95"
				height="30"
				rx="5"
				fill="rgba(123,47,247,0.2)"
				stroke="#7b2ff7"
				strokeWidth="1.2"
			/>
			<rect
				x="123"
				y="50"
				width="48"
				height="4"
				rx="2"
				fill="rgba(255,255,255,0.3)"
			/>
			<rect
				x="123"
				y="58"
				width="32"
				height="3"
				rx="1.5"
				fill="rgba(255,255,255,0.15)"
			/>
			<circle cx="197" cy="58" r="6" fill="rgba(123,47,247,0.4)" />
			<path
				d="M194 58l2 2 4-4"
				stroke="#7b2ff7"
				strokeWidth="1.5"
				fill="none"
				strokeLinecap="round"
			/>
		</svg>
	),
};

/** SNOW mascot for the hero section */
export const SnowMascot: React.FC = () => (
	<svg
		width="160"
		height="176"
		viewBox="0 0 200 220"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		className="snow-home__snow-mascot"
	>
		{/* Body - bottom */}
		<ellipse cx="100" cy="170" rx="60" ry="45" fill="rgba(255,255,255,0.9)" />
		{/* Body - middle */}
		<ellipse cx="100" cy="115" rx="45" ry="35" fill="rgba(255,255,255,0.92)" />
		{/* Head */}
		<circle cx="100" cy="70" r="30" fill="rgba(255,255,255,0.95)" />
		{/* Top hat - tilted for fun */}
		<g transform="rotate(-12, 100, 30)">
			<rect
				x="75"
				y="30"
				width="50"
				height="6"
				rx="2"
				fill="rgba(255,255,255,0.6)"
			/>
			<rect
				x="82"
				y="6"
				width="36"
				height="26"
				rx="3"
				fill="rgba(255,255,255,0.5)"
			/>
			{/* Hat band */}
			<rect
				x="82"
				y="24"
				width="36"
				height="5"
				rx="1"
				fill="#00b4d8"
				opacity="0.5"
			/>
		</g>
		{/* Eyes - happy/winking */}
		<circle cx="89" cy="64" r="3.5" fill="rgba(50,50,50,0.6)" />
		<path
			d="M108 62 Q112 67 116 62"
			stroke="rgba(50,50,50,0.6)"
			strokeWidth="2.5"
			fill="none"
			strokeLinecap="round"
		/>
		{/* Eye sparkle */}
		<circle cx="90.5" cy="62.5" r="1.2" fill="rgba(255,255,255,0.8)" />
		{/* Rosy cheeks */}
		<ellipse cx="84" cy="74" rx="6" ry="3.5" fill="rgba(255,150,150,0.2)" />
		<ellipse cx="116" cy="74" rx="6" ry="3.5" fill="rgba(255,150,150,0.2)" />
		{/* Carrot nose */}
		<path d="M98 70 L108 74 L98 78 Z" fill="#ff9900" opacity="0.8" />
		{/* Big smile */}
		<path
			d="M88 82 Q100 94 112 82"
			stroke="rgba(50,50,50,0.5)"
			strokeWidth="2"
			fill="none"
			strokeLinecap="round"
		/>
		{/* Buttons */}
		<circle cx="100" cy="105" r="3" fill="rgba(50,50,50,0.4)" />
		<circle cx="100" cy="118" r="3" fill="rgba(50,50,50,0.4)" />
		<circle cx="100" cy="131" r="3" fill="rgba(50,50,50,0.4)" />
		{/* Scarf - flowing */}
		<path
			d="M70 88 Q100 100 130 88"
			stroke="#00b4d8"
			strokeWidth="6"
			fill="none"
			strokeLinecap="round"
			opacity="0.7"
		/>
		<path
			d="M122 90 Q128 108 118 118"
			stroke="#00b4d8"
			strokeWidth="5"
			fill="none"
			strokeLinecap="round"
			opacity="0.55"
		/>
		<path
			d="M118 118 L122 120"
			stroke="#00b4d8"
			strokeWidth="4"
			fill="none"
			strokeLinecap="round"
			opacity="0.4"
		/>
		{/* Stick arms - waving */}
		<path
			d="M55 115 L25 90"
			stroke="rgba(255,255,255,0.35)"
			strokeWidth="3"
			strokeLinecap="round"
		/>
		<path
			d="M25 90 L18 80"
			stroke="rgba(255,255,255,0.3)"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
		<path
			d="M25 90 L20 95"
			stroke="rgba(255,255,255,0.3)"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
		<path
			d="M145 115 L170 95"
			stroke="rgba(255,255,255,0.35)"
			strokeWidth="3"
			strokeLinecap="round"
		/>
		<path
			d="M170 95 L178 88"
			stroke="rgba(255,255,255,0.3)"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
		<path
			d="M170 95 L175 100"
			stroke="rgba(255,255,255,0.3)"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
		{/* Snowflakes around */}
		<text
			x="15"
			y="60"
			fill="rgba(255,255,255,0.35)"
			fontSize="24"
			fontFamily="sans-serif"
		>
			❄
		</text>
		<text
			x="162"
			y="48"
			fill="rgba(255,255,255,0.3)"
			fontSize="20"
			fontFamily="sans-serif"
		>
			❄
		</text>
		<text
			x="35"
			y="185"
			fill="rgba(255,255,255,0.25)"
			fontSize="18"
			fontFamily="sans-serif"
		>
			❄
		</text>
		<text
			x="152"
			y="175"
			fill="rgba(255,255,255,0.25)"
			fontSize="22"
			fontFamily="sans-serif"
		>
			❄
		</text>
		{/* Snow ground */}
		<ellipse cx="100" cy="212" rx="80" ry="8" fill="rgba(255,255,255,0.15)" />
	</svg>
);
